<template>
  <div>


    <div class="container">

      <div class="row">

        <div class="my-5 col-lg-4" v-for="course in getCourses" :key="course.id">
          <m-course-card1 :course="course"/>
        </div>

        <div class="col-lg-12 text-center">
          <!-- show Pagination if havePagination props is true -->
          <m-paginate1 class='mt-4 ml-auto mr-auto'
                       v-if="paginate"
                       :meta="meta"
                       :on-change-page="changePage"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import mPaginate1 from "../../Pagination/Paginate1";
import {CourseArchiveProps} from "./CourseArchiveProps";
import mCourseCard1 from "../Card/CourseCard1";

export default {
  name: "Course",
  components: {mPaginate1, mCourseCard1,},
  props: {
    ...CourseArchiveProps
  },
  computed: {
    ...mapGetters({
      courses: "Course/getCourses",
      meta: "Course/getPaginationMeta",
    }),
    getCourses() {
      if (this.slicer) {
        const course = this.courses;
        return course.slice(0, this.slicer)
      } else {
        return this.courses
      }
    }
  },
  methods: {
    changePage(page) {
      this.$store.dispatch("Course/setCourses", page);
    },
  },
  async mounted() {
    await this.$store.dispatch("Course/setCourses", 1);
  },
};
</script>